// dependencies
import { List } from "immutable";

import { getIsGoalDashboardEnabled } from "./settings";

export const getObjectPermission = (state, domain, objectID) =>
	state.permissions?.getIn([domain, "objects", objectID, "permissions"], List());
export const getUserHasObjectPermission = (state, domain, objectID, permissionName) =>
	getObjectPermission(state, domain, objectID)?.includes(permissionName);

// review cycles

export const getCanUserEditRedactedness = (state, notSetValue = false) => {
	if (!state.permissions.has("reviewCycles")) {
		return notSetValue;
	}

	return state.permissions
		.getIn(["reviewCycles", "permissionList"], List())
		.contains("edit-cycle-forms-redactedness");
};

// goals

export const getCanUserViewOverview = (state, notSetValue = false) => {
	if (!state.permissions.has("goals")) {
		return notSetValue;
	}

	const viewOverviewAllEnabled = state.settings.getIn(
		["company", "goals", "attributes", "overviewVisibleToAllUsers"],
		false
	);

	const viewOverviewPermission = state.permissions
		.getIn(["goals", "permissionList"], List())
		.contains("goals:viewGoalsOverviewDashboard");

	const isGoalDashboardEnabled = getIsGoalDashboardEnabled(state);

	return isGoalDashboardEnabled && (viewOverviewAllEnabled || viewOverviewPermission);
};

export const getCanUserViewAlignment = (state, notSetValue = false) => {
	if (!state.permissions.has("goals")) {
		return notSetValue;
	}

	const viewAlignmentEnabled = state.settings.getIn(
		["company", "goals", "attributes", "treeVisibleToAllUsers"],
		false
	);

	const viewAlignmentPermission = state.permissions
		.getIn(["goals", "permissionList"], List())
		.contains("goals:viewGoalsAlignmentTree");

	const isGoalDashboardEnabled = getIsGoalDashboardEnabled(state);

	return isGoalDashboardEnabled && (viewAlignmentEnabled || viewAlignmentPermission);
};

export const getCanUserViewGoalList = (state, notSetValue = false) => {
	if (!state.permissions.has("goals")) {
		return notSetValue;
	}

	const viewListAllEnabled = state.settings.getIn(["company", "goals", "attributes", "listVisibleToAllUsers"], false);

	const viewListPermission = state.permissions
		.getIn(["goals", "permissionList"], List())
		.contains("goals:viewCompanyGoalsList");

	const canViewList = viewListAllEnabled || viewListPermission;

	return canViewList;
};

export const getCanUserExportGoalsCsv = (state, notSetValue = false) => {
	if (!state.permissions.has("goals")) {
		return notSetValue;
	}

	return state.permissions.getIn(["goals", "permissionList"], List()).contains("goals:exportGoalCsv");
};

export const getCanUserViewFullReviewStatus = (state, notSetValue = false) => {
	if (!state.permissions.has("reviews")) {
		return notSetValue;
	}

	return state.permissions.getIn(["reviews", "permissionList"], List()).contains("create-reviews");
};

export const getCanUserViewAuthenticationApi = (state, notSetValue = false) => {
	const permissions = state.permissions.toJS();

	if (!permissions?.rbacPermissionsList) {
		return notSetValue;
	}

	return permissions.rbacPermissionsList.includes("external_api:viewExternalApiKey");
};
